import { Component } from '@angular/core';
import { AuthService } from '@app/services';
import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';
import { EmploymentType } from '@models/employee/employment-type.model';

@Component({
    selector: 'employment-type-display-component',
    template: `
        <div>
            @if (employmentType) {
                {{ employmentType.name | appTranslateOptions: employmentTypeDisplayOptions | capitalize }}
            } @else {
                -
            }
        </div>
    `,
})
export class EmploymentTypeDisplayComponent implements DisplayComponentInterface {
    value = '';
    employmentType: EmploymentType | null = null;
    translatedEmploymentType = '';
    employmentTypeDisplayOptions = EmploymentTypeDisplayOptions;

    constructor(private auth: AuthService) {}

    async ngOnInit(): Promise<void> {
        if (this.value) {
            this.employmentType = await EmploymentType.param('company', this.auth.company.id).find(this.value);
        }
    }
}
